import { defineStore } from 'pinia'
import { request } from '../../scripts/utils'
import { setUser } from '../../scripts/datalog'
import { useI18n } from 'vue-i18n'
// 定义用户信息store
export const useUserStore = defineStore('user', {
  // 状态
  state: () => ({
    userData: null
  }),
  
  // getters
  getters: {
    // 获取用户信息
    getUserData: (state) => state.userData,
    // 判断是否有用户信息
    hasUser: (state) => !!state.userData
  },
  
  // actions
  actions: {
    // 获取用户信息
    async fetchUserData() {
      const { t } = useI18n()
      try {
        const authRes = await request('auth/currentUserInfo', null, true, 'POST', true)
        if (authRes?.status === 200) {
          const res = await authRes.json()
          this.userData = res.data
          sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(res.data))
          
          setUser({
            id: res.data.userId,
            email: res.data.email
          })
          const customerNameEl = document.querySelector('.customer-name')
          if (res.data?.surname && res.data?.name) {
            customerNameEl.textContent = `${res.data.surname} ${res.data.name}`
          } else {
            customerNameEl.textContent = t('landing.unnamed')
          }
        }
      } catch (error) {}
      
      return this.userData
    },
    
    // 设置用户数据（用于从外部直接设置数据）
    setUserData(data) {
      this.userData = data
    },

    // 清除用户数据（用于登出）
    clearUserData() {
      this.userData = null
    }
  }
}) 